import React, { useContext } from 'react'
import Space from '../../atoms/Space'
import { View } from '../../other/html'
import ListLeftColumn from './ListLeftColumn'
import ListPriceColumn from './ListPriceColumn'
import Expanded from './Expanded'
import { ItemContext, ItemDispatchContext } from 'src/contexts/itemContext'

const Item = (): JSX.Element => {
  const itemContext = useContext(ItemContext)
  const dispatchItemContext = useContext(ItemDispatchContext)

  if (itemContext === null || dispatchItemContext === null) {
    throw new Error('itemContext must be used within a ItemProvider')
  }

  const { index, expandedView } = itemContext
  const backgroundColor = (i: number): string => (i % 2 === 0 ? 'bg-lightGrey' : 'bg-white')
  const radiusStyles = expandedView ? 'rounded-b-4 rounded-t-2' : 'rounded-2'
  const cursorStyles = expandedView ? 'cursor-default' : 'cursor-pointer'
  return (
    <View
      data-testid="liked-item"
      className={`shadow-bothSmall w-full mb-4 ${backgroundColor(index)} ${radiusStyles} ${cursorStyles}`}
      onClick={() => {
        dispatchItemContext({ type: 'EXPAND_VIEW' })
      }}>
      <Space y={2} />
      <View className="flex justify-between">
        <ListLeftColumn />
        <ListPriceColumn />
      </View>
      <Space y={2} />
      <Expanded expandedView={expandedView} />
    </View>
  )
}

export default React.memo(Item)
